module.exports = __webpack_public_path__ + "static/img/title_comment.484ecae.png";


//////////////////
// WEBPACK FOOTER
// ./static/funding_cpunk/creation/title_comment.png
// module id = 2GCm
// module chunks = 1